import http from '../utils/http';
// import qs from 'qs' 

const projectConfig = {
    /**
     * 分页获取服务项目列表
     */
    getProjectByPage(options = {}, config = {}) {
        return http.get('/serviceProject/getProjectByPage', options, {
            ...config
        })
    },

    /**
     * 新增服务项目
     */
    addProject(options = {}, config = {}) {
        return http.post('/serviceProject/addProject', options, {
            ...config
        })
    },

    /**
     * 修改服务项目
     */
    updateProject(options = {}, config = {}) {
        return http.post('/serviceProject/updateProject', options, {
            ...config
        })
    },
    /**
     * 启用/禁用服务项目
     */
    stopStatus(options = {}, config = {}) {
        return http.post('/serviceProject/stopStatus', options, {
            ...config
        })
    },
    /**
     * 删除服务项目
     */
    deleteProject(serviceId='') {
        return http.delete(`/serviceProject/deleteProject?serviceId=${serviceId}`)
    }
}

export default projectConfig;
